import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

import favicon from "../../assets/images/p.ico"

require("dotenv").config()

function SEO({ lang, meta }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = meta.description || site.siteMetadata.description
  const customTitle = meta.title || site.siteMetadata.title
  const author = meta.author || site.siteMetadata.author

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={customTitle}
      titleTemplate={`%s | ${site.siteMetadata.author}`}
      // meta={[
      //   {
      //     name: `description`,
      //     content: metaDescription,
      //   },
      //   {
      //     property: `og:title`,
      //     content: customTitle,
      //   },
      //   {
      //     property: `og:description`,
      //     content: metaDescription,
      //   },
      //   {
      //     property: `og:type`,
      //     content: `website`,
      //   },
      //   {
      //     name: `twitter:card`,
      //     content: `summary`,
      //   },
      //   {
      //     name: `twitter:creator`,
      //     content: author,
      //   },
      //   {
      //     name: `twitter:title`,
      //     content: customTitle,
      //   },
      //   {
      //     name: `twitter:description`,
      //     content: metaDescription,
      //   },
      // ].concat(meta.meta)}
    >
      <meta name="description" content={metaDescription} />
      <meta name="og:title" content={customTitle} />
      <meta name="og:description" content={metaDescription} />
      <meta name="keywords" content={meta.meta[0].content} />
      <meta
        name="google-site-verification"
        content="UbCqIyPjaESUcPZ7IE-Lq61We4Ufb0qkcniKlFY6NdQ"
      />
      <link rel="icon" type="text/css" href={favicon} />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/cookieconsent2/3.1.1/cookieconsent.min.css"
      />
      <script
        src="https://cdnjs.cloudflare.com/ajax/libs/cookieconsent2/3.1.1/cookieconsent.min.js"
        defer={false}
        data-cfasync="false"
      ></script>
      
      <script>
        {typeof window !== "undefined"
          ? window.addEventListener("load", function () {
              window.cookieconsent.initialise({
                revokeBtn: "<div class='cc-revoke'></div>",
                type: "opt-out",
                theme: "classic",
                palette: {
                  popup: {
                    background: "#1E1E1E",
                    text: "#ffffff",
                  },
                  button: {
                    background: "#ec3f2b",
                    text: "#ffffff",
                  },
                },
                content: {
                  message:
                    "Oldalunkon HTTP-sütiket használunk a jobb működésért.",
                  allow: "Rendben",
                  deny: "Elutasítom",
                  link: "Adatvédelmi tájékoztató",
                  href: "https://prodhost.com/adatkezelesi_tajekoztato.pdf",
                },
                onInitialise: function (status) {
                  if (status === window.cookieconsent.status.allow) myScripts()
                },
                onStatusChange: function (status) {
                  if (this.hasConsented()) myScripts()
                },
              })
              function myScripts() {}
            })
          : null}
      </script>
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  description: ``,
  title: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default SEO
